/**
 * @description Can be swapped with the primary success color.
 */

const green = {
  25: "#F6FEF9",
  50: "#EDFCF2",
  100: "#D3F8DF",
  200: "#AAF0C4",
  300: "#73E2A3",
  400: "#3CCB7F",
  500: "#16B364",
  600: "#099250",
  700: "#087443",
  800: "#095C37",
  900: "#084C2E",
  950: "#052E1C",
};

export default green;
